module.exports = __webpack_public_path__ + "img/recette-edit-4qteassiette.1c3e1f32.png";